// extracted by mini-css-extract-plugin
export default {"notification":"PopupNotification_notification__Ozxt+","hidden":"PopupNotification_hidden__GDDoG"};